import React from "react";
import style from "./App.module.scss";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Clients from "../Clients/Clients";
import Visits from "../Visits/Visits";
import NavBar from "../NavBar/NavBar";
import VisitDetails from "../VisitDetails/VisitDetails";
import PrivateRoute from "../Auth/PrivateRoute";
import { LoginProvider } from "../../store/store";
import Login from "../Auth/Login";
import Offers from "../Offers/Offers";
import AddOffer from "../Offers/components/AddOffer/AddOffer";
import EditOffer from "../Offers/components/EditOffer/EditOffer";
import { Blog } from "../Blog/Blog";
import { NewArticle } from "../Blog/components/NewArticle/NewArticle";
import { EditArticle } from "../Blog/components/EditArticle/EditArticle";
import Pages from "../Pages/Pages";
import AddPage from "../Pages/components/AddPage/AddPage";
import EditPage from "../Pages/components/EditPage/EditPage";
import Media from "../Media/Media";

function App() {
  return (
    <div className={style.App}>
      <LoginProvider>
        <Router>
          <NavBar />
          <Switch>
            <Route component={Login} path="/login" />
            <PrivateRoute component={Visits} exact path="/" />
            <PrivateRoute component={Clients} path="/clients" />
            <PrivateRoute exact component={Offers} path="/offers" />
            <PrivateRoute exact component={Blog} path="/blog" />
            <PrivateRoute exact component={NewArticle} path="/blog/new" />
            <PrivateRoute exact component={EditArticle} path="/blog/:id" />
            <PrivateRoute exact component={AddOffer} path="/offers/new" />
            <PrivateRoute exact component={EditOffer} path="/offers/:id" />
            <PrivateRoute exact component={Pages} path="/pages" />
            <PrivateRoute exact component={AddPage} path="/pages/new" />
            <PrivateRoute exact component={EditPage} path="/pages/:id" />
            <PrivateRoute exact component={Media} path="/media" />
            <PrivateRoute component={VisitDetails} path="/visit/details/:id" />
          </Switch>
        </Router>
      </LoginProvider>
    </div>
  );
}

export default App;
